import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { emailRegExp } from '../../../shared/validators/pattern.validators';
import { AuthenticationService } from '../../../shared/store/authentication/authentication.service';
import { filter, take } from 'rxjs/operators';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    host: { class: 'connection-form p-4 col-12 col-sm-8' },
    standalone: false
})
export class ForgotPasswordComponent implements OnInit {
  showErrorLogin: any;
  returnUrl: string;
  css: string = 'alert-danger';
  msgError: string = 'LOGIN_LBL_PASSWORD_FORGOT_ERROR';

  forgotPasswordForm: FormGroup;

  constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly formBuilder: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.returnUrl = '/';

    this.forgotPasswordForm = this.formBuilder.group({
      email: new FormControl('', [
        Validators.required,
        Validators.pattern(emailRegExp),
      ]),
    });
  }

  onSubmit() {
    this.showErrorLogin = false;
    if (this.forgotPasswordForm.invalid) {
      this.forgotPasswordForm.markAllAsTouched();
      this.showErrorLogin = true;
      return;
    }

    let result$ = this.authenticationService.forgotPassword.call({
      email: this.forgotPasswordForm.value.email!,
    });

    result$
      .pipe(
        filter((x) => x !== undefined),
        take(1),
      )
      .subscribe({
        next: (result) => {
          if (result) {
            this.css = 'alert-success';
            this.msgError = 'LOGIN_LBL_PASSWORD_FORGOT_SUCCESS';
            this.showErrorLogin = true;

            console.log('mail sent');
            // this.forgotPasswordForm.reset();
          } else {
            this.css = 'alert-danger';
            this.msgError = 'LOGIN_LBL_PASSWORD_FORGOT_FAIL';
            this.showErrorLogin = true;
          }
        },
        error: () => {
          this.css = 'alert-danger';
          this.msgError = 'LOGIN_LBL_PASSWORD_FORGOT_FAIL';
          this.showErrorLogin = true;
        },
      });
  }
}
